import { ReactNode } from 'react';
import { Box, Button, Typography, makeStyles } from '@material-ui/core';

interface PendingInteractionSurfaceProps {
  title: string;
  helperText?: string;
  noticeText?: string;
  primaryActionLabel?: string;
  onPrimaryAction?: () => void;
  secondaryActionLabel?: string;
  onSecondaryAction?: () => void;
  children: ReactNode;
}

const useStyles = makeStyles(theme => ({
  root: {
    border: `1px solid ${theme.palette.secondary.main}`,
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(2),
  },
  title: {
    fontWeight: 700,
    color: theme.palette.secondary.main,
    marginBottom: theme.spacing(1),
  },
  helperText: {
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(1.5),
  },
  noticeBox: {
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.grey[100],
    border: `1px solid ${theme.palette.divider}`,
    padding: theme.spacing(1.25, 1.5),
    marginBottom: theme.spacing(1.5),
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: theme.spacing(1),
    marginTop: theme.spacing(2),
  },
}));

export const PendingInteractionSurface = ({
  title,
  helperText,
  noticeText,
  primaryActionLabel,
  onPrimaryAction,
  secondaryActionLabel,
  onSecondaryAction,
  children,
}: PendingInteractionSurfaceProps) => {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <Typography variant="h6" className={classes.title}>
        {title}
      </Typography>

      {helperText && (
        <Typography variant="body2" className={classes.helperText}>
          {helperText}
        </Typography>
      )}

      {noticeText && (
        <Box className={classes.noticeBox}>
          <Typography variant="body2">{noticeText}</Typography>
        </Box>
      )}

      {children}

      {(primaryActionLabel || secondaryActionLabel) && (
        <Box className={classes.actions}>
          {secondaryActionLabel && onSecondaryAction && (
            <Button
              onClick={onSecondaryAction}
              aria-label={secondaryActionLabel}
            >
              {secondaryActionLabel}
            </Button>
          )}
          {primaryActionLabel && onPrimaryAction && (
            <Button
              variant="outlined"
              color="secondary"
              onClick={onPrimaryAction}
            >
              {primaryActionLabel}
            </Button>
          )}
        </Box>
      )}
    </Box>
  );
};
